'use client';

import { Button } from '@/components/primitives/Button';
import { GA_EVENTS, GA_PARAMS } from '@/constants/analytics';
import { trackEvent } from '@/lib/analytics/trackEvent';

import type { ButtonProps } from '@/components/primitives/Button';
import type { GaCtaId, GaCtaPlacement } from '@/constants/analytics';
import type { MouseEvent } from 'react';

type TrackedCtaButtonProps = Extract<ButtonProps, { href: string }> & {
  ctaId: GaCtaId;
  placement: GaCtaPlacement;
};

/**
 * Client leaf wrapping `Button` (anchor) to fire `cta_click` without
 * promoting a parent layout shell to `'use client'`.
 */
export function TrackedCtaButton({
  ctaId,
  placement,
  onClick,
  ...buttonProps
}: TrackedCtaButtonProps) {
  return (
    <Button
      {...buttonProps}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => {
        trackEvent(GA_EVENTS.ctaClick, {
          [GA_PARAMS.ctaId]: ctaId,
          [GA_PARAMS.placement]: placement,
        });
        onClick?.(event);
      }}
    />
  );
}
